// extracted by mini-css-extract-plugin
export default {"pictures":"home_pictures__B-PZU","scroll_container":"home_scroll_container__+ZGQM","slide":"home_slide__gMTxL"};